export default function makeQueryString(formData: FormData) {
	let queryString = "";
	if (formData) {
		const formEntries = new Set(formData.entries());
		formEntries.forEach(
			(entry: any) =>
				(queryString += `${encodeURIComponent(entry[0])}=${encodeURIComponent(
					entry[1]
				)}&`)
		);
	}
	return queryString;
}